import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, userName }) => {
  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-foreground/50 z-40 animate-fade-in"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-md animate-scale-in">
          <div className="p-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center">
                <Icon name="AlertTriangle" size={24} className="text-error" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-card-foreground">Delete User</h2>
                <p className="text-sm text-muted-foreground mt-1">This action cannot be undone</p>
              </div>
            </div>

            <p className="text-card-foreground mb-6">
              Are you sure you want to delete <span className="font-semibold">{userName}</span>? All associated data including quiz progress, badges, and activity history will be permanently removed.
            </p>

            <div className="flex items-center gap-3">
              <Button
                variant="destructive"
                fullWidth
                onClick={onConfirm}
                iconName="Trash2"
                iconPosition="left"
              >
                Delete User
              </Button>
              <Button
                variant="outline"
                fullWidth
                onClick={onClose}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmModal;